const light = {
  white: "#fafafa",
  white01: "#EFF2F5",
  gray: "#555",
  gray01: "#e1e1e6",
  gray02:"#40739e",
  gray03:"#ccc",
  gray600: "#757575",
  black: "#000c17",
  black01: "#121214",
  black02: "#29292E",
  black03: "#020202",
  black04:"#000000",
  blue: "#2383c0",
  green: "#065804",
  green01:"#065111",
  red: "#ff6659",
  jujubeRed: "#d37368",
  A700: "#2979FF",
  orangeA100: "#FFD180",
  orange900: "#FF9800",
  theme01: "#e58e26",
  theme02:"#e58e2655",
  blueGray: "#37474F",
  teal600: "#00897B",
};
const dark = {
  white: "#000e17",
  white01: "#f7f8fa",
  gray: "#ccc",
  gray01: "#f0f0f2",
  gray02:"#40739e",
  gray03:"#888",
  black: "#ffffff",
  black01: "#f0f0f0cc",
  black02: "#fffffe",
  black03: "#808080",
  black04:"#000000",
  blue: "#2383c0",
  green: "#82ab81",
  green01:"#065111",
  red: "#d32f2f",
  jujubeRed: "#d37368",
  A700: "#64B5F6",
  orangeA100: "#FFE0B2",
  orange900: "#FF9800",
  theme01: "#e58e26",
  theme02:"#e58e2655",
  gray600: "#E0E0E0",
  blueGray: "#B0BEC5",
  teal600: "#26A69A",
};

const Colors = {
  light,
  dark,
};
export default Colors;
